import React, { useState } from 'react'
import { FaComment, FaEllipsisV, FaEnvelope, FaFlag, FaInfoCircle, FaMarker, FaMinusCircle, FaPen, FaRegThumbsUp, FaSave, FaShare, FaThumbsUp, FaTimes, FaTrash } from 'react-icons/fa'
import storeImg from "../../assets/store1.png"
import moment from "moment"
import { useNavigate } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'


const Product = ({ ad }) => {
    const [profileInfo, setProfileInfo] = useState(false)
    const [adInfo, setadInfo] = useState(false)
    const [liked, setLiked] = useState(false)
    const [likesCount, setLikesCount] = useState(ad.likesCount)

    // console.log("productad:", ad)

    const navigate = useNavigate()

    const imageFiles = ad?.product.files?.filter(f => f.type === "image") || [];
    const [focusedImg, setFocusedImg] = useState(imageFiles[0]?.url || null);

    const toogleadInfo = () => {
        setProfileInfo(false)
        setadInfo(!adInfo)
    }
    const toogleProfileInfo = () => {
        setProfileInfo(!profileInfo)
        setadInfo(false)
    }

    const renderImages = () => (
        <>
            <div className="focused-image">
                <img src={focusedImg} alt="onnize" />
            </div>

            {imageFiles.length > 0 && (
                <div className="image-selector">
                    {imageFiles.map((file, i) => (
                        <div
                            key={i}
                            className="image-selector-wrapper"
                            onClick={() => setFocusedImg(file.url)}
                        >
                            <img src={file.url} alt={file.name} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );

    const renderVideo = (file) => (
        <div className="video-container">
            <video controls>
                <source src={file.url} type={file.mimeType} />
            </video>
        </div>
    );


    const renderFiles = () => {
        if (!ad.product.files?.length) return null;

        switch (ad.product.files[0].type) {
            case "image":
                return renderImages();
            case "video":
                return renderVideo(ad.files[0]);
            default:
                return null;
        }
    };

    return (
        <div className='ad'>
            <div className="ad-header">
                <div className="profile-details"
                    onClick={() => navigate(`/b/${ad.product.store.name}`)}
                >
                    <img
                        src={ad.product.store?.logo.url ? ad.product.store.logo.url : storeImg}
                        alt="user profile"
                        className="userad-profile-img"
                    />
                    <div className="ad-data-details">
                        <div className="ad-profile-name">
                            <p>{ad.product.store?.name}</p>
                        </div>
                    </div>
                    <p className='promoted-label'>promoted</p>
                </div>
                <div className=""
                    onClick={toogleProfileInfo}
                >
                    <FaEllipsisV />
                </div>
            </div>
            <div className="ad-body">
                <div className={profileInfo ? "profile-info" : "closed-info"}>
                    <FaTimes onClick={toogleProfileInfo} />
                    <div className="ad-button-wrapper">
                        <FaMarker />
                        <button className="ad-info-btn">Follow</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaEnvelope />
                        <button className="ad-info-btn">Message</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaMinusCircle />
                        <button className="ad-info-btn">Block</button>
                    </div>
                </div>
                <div className={adInfo ? "ad-info" : "closed-info"}>
                    <FaTimes onClick={toogleadInfo} />
                    <div className="ad-button-wrapper">
                        <FaSave />
                        <button className="ad-info-btn">Bookmark</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaShare />
                        <button className="ad-info-btn">Share to</button>
                    </div>
                    <div className="share-options">
                        <p className="share-option">My Profile</p>
                        <p className="share-option">Organization</p>
                        <p className="share-option">see more...</p>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaFlag />
                        <button className="ad-info-btn">Report</button>
                    </div>
                </div>
                {
                    ad?.product.description &&
                    <div className="feed-ad-text"
                        onClick={() => navigate(`/b/${ad.product.store.name}/products/${ad.product._id}`, { state: { product: ad.product } })}

                    >
                        <p>{ad.product.description}</p>
                    </div>
                }
                <div className="adcard-images">
                    {renderFiles()}
                </div>
            </div>

            <div className="ad-footer">
                <div className="ad-footer-icon">
                    <p onClick={() => navigate(`/b/${ad.product.store.name}/products/${ad.product._id}`, { state: { product: ad.product } })}
                        >See more</p>
                </div>
                <div
                    className="ad-footer-icon"
                    onClick={toogleadInfo}
                >
                    <FaInfoCircle />
                </div>
            </div>
        </div>
    )
}

export default Product